import Vue from 'vue';
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'

new Vue({
  el: '#logo_slider',
  name: 'logo_slider',
  components: { VueSlickCarousel },
  data() {
    return {
      settings: {
        "autoplay": true,
        "focusOnSelect": false,
        "pauseOnHover": true,
        "infinite": true,
        "speed": 1000,
        "autoplaySpeed": 3000,
        slidesToShow: 5,
        centerMode: true,
        adaptiveHeight: true,
        arrows: false,
        variableWidth: true,
        "responsive": [
          {
            "breakpoint": 1024,
            "settings": {
              "infinite": true,
              "slidesToShow": 3,
              "slidesToScroll": 3,
            }
          },
          {
            "breakpoint": 600,
            "settings": {
              centerMode: true,
              "infinite": true,
              "slidesToShow": 1,
              "slidesToScroll": 1,
            }
          },
          {
            "breakpoint": 480,
            "settings": {
              centerMode: true,
              "infinite": true,
              "slidesToShow": 1,
              "slidesToScroll": 1
            }
          }
        ]
      }
    }
  },
});